import {createSlice} from "@reduxjs/toolkit";

const TripsFilterSlicer = createSlice({
    name: 'tripFilter',
    initialState: {
        distance: 750,
        vehicles: [],
        groups: [],
    },
    reducers: {
        tripVehicleFilter: (state, action) => {
            if (state.vehicles.includes(action.payload)) {
                const index = state.vehicles.indexOf(action.payload);
                state.vehicles.splice(index, 1);
            } else {
                state.vehicles.push(action.payload);
            }
        },
        tripGroupFilter: (state, action) => {
            if (state.groups.includes(action.payload)) {
                const index = state.groups.indexOf(action.payload);
                state.groups.splice(index, 1);
            } else {
                state.groups.push(action.payload);
            }
        },
        tripDistanceFilter: (state, action) => {
            state.distance = action.payload
        }
    }
})

export default TripsFilterSlicer.reducer;
export const {
    tripDistanceFilter,
    tripVehicleFilter,
    tripGroupFilter} = TripsFilterSlicer.actions;
